module.exports = __webpack_public_path__ + "static/media/groceries.fb8edef0.png";